import { FC, memo } from 'react'
import { NodeProps, Position } from '@xyflow/react'
import MergeTypeIcon from '@mui/icons-material/MergeType'
import BaseNode from './BaseNode'
import { MergeNodeData } from '../types'

const MergeNode: FC<NodeProps> = ({ id, data, selected }) => {
  const nodeData = data as MergeNodeData
  const subtitle = nodeData.strategy === 'wait_all' ? 'Wait for all' : 'First result'

  return (
    <BaseNode
      nodeType="merge"
      icon={<MergeTypeIcon fontSize="small" />}
      label={nodeData.label}
      nodeId={id}
      subtitle={subtitle}
      selected={selected}
      handles={[
        { type: 'target', position: Position.Top, id: 'in-1', style: { left: '30%' } },
        { type: 'target', position: Position.Top, id: 'in-2', style: { left: '70%' } },
        { type: 'source', position: Position.Bottom },
      ]}
    />
  )
}

export default memo(MergeNode)
